import OnbTable from "../components/Onboarding/OnbTable";

const Onboarded = () => {
    return <OnbTable />;
};

export default Onboarded;
